import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShareOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0004 13.2999C22.0004 17.5525 18.553 20.9999 14.3003 20.9999C10.0477 20.9999 11.3669 18.2858 11.3669 14.0332C-0.733317 6.69988 11.5142 6.69989 15.7668 6.69989C20.0194 6.69989 22.0004 9.04729 22.0004 13.2999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9997 1.77295L8.57861 9.21011",
			stroke: "#454545",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1829 19.9736L22 1.77393H1L8.57891 9.21108L11.1829 19.9736Z",
			stroke: "#454545",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})
	]
});
export default SvgShareOutline;
